<template>
  <div class="save-regimen modal-container">
    <div class="modal-wrapper">
      <div class="modal-content">
        <h3>Keep up the good work!</h3>
        <div class="body">
          <p>We have your information plugged in.</p>
          <p>Let’s see what your completed regimen looks like!</p>
        </div>
        <a @click="handleClick">
          View Regimen
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";

export default {
  name: "RegimenBuilderModal",

  mixins: [profileMixin],

  methods: {
    handleClick() {
      this.showModal(false);
      this.$router.push('/regimen-calendar')
    }
  }
}
</script>

<style scoped>
.body {
  margin-top: 18px;
}
.body p {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15.4254px;
  line-height: 28px;
  /* or 182% */

  text-align: center;
  letter-spacing: 0.5px;

  color: rgba(0, 0, 0, 0.38);
}

.modal-content a {
  max-width: 250px;
  margin-top: 27px;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13.4237px;
  line-height: 16px;
  /* identical to box height, or 119% */

  text-align: center;
  letter-spacing: 1.25px;
  text-transform: uppercase;

  color: #FFFFFF;
  background-color: #603975;

}
</style>



// WEBPACK FOOTER //
// src/components/modals/RegimenBuilder/RegimenBuilderModal.vue